exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".xTVL3X6ILXNa_wMoZxyYQ{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.uKmyEj7MdnZ0viseZClnm{width:39px;height:39px}", ""]);
// Exports
exports.locals = {
	"spinnerContainer": "xTVL3X6ILXNa_wMoZxyYQ",
	"spinner": "uKmyEj7MdnZ0viseZClnm"
};